import CritiqueReviewReadyBanner from './CritiqueReviewReadyBanner'
export default CritiqueReviewReadyBanner
